import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { environment } from './../../../../../environments/environment';

import { IsActive } from './../../../../model';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class JobSummaryService {
  private url: string = environment.appUrl;
  constructor(
    private http: HttpClient
  ) {}

  getSummary(startDate: string, endDate: string, jobStatus: number, customerStatus: number, all: boolean, customerId: number) {
    let getSummaryUrl;
    let params = new HttpParams();

    if (all) {
      getSummaryUrl = this.url + 'jobs';

      params = params.set('start-date', startDate);
      params = params.set('end-date', endDate);
      params = params.set('job-completion', jobStatus.toString());
      params = params.set('customer-status', IsActive.both.toString());
    }
    else {
        getSummaryUrl = this.url + 'customers/' + customerId + '/job-summary';

        if (startDate != null && endDate != null) {
          params = params.set('start-date', startDate);
          params = params.set('end-date', endDate);

        }
        params = params.set('job-completion', jobStatus.toString());
        params = params.set('customer-status', IsActive.both.toString());
    }

    return this.http
      .get(getSummaryUrl, {
        params: params,
        observe: 'response'
      })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/job/job-summary/job-summary.service.ts